import React from 'react';
import News from '../news';

const Events = () => {

  return (
    <News
    pageTitle="Events And Training"
    metaTitle="Events And Training - FORLAND"
    bannerImage="/assets/images/bg1.png"
    to="/events-and-training"
     category='Events and Trainings'
  />
  );
};

export default Events;